






import Component from "vue-class-component";
import Vue from "vue";
import { namespace } from "vuex-class";
import { StateStatRoles } from "@/store/types";
import { Dictionary } from "@/types";
import { ACTION_TYPES } from "@/lib/const";
import config from "@/config";
import { $t } from "@/lib/helpers/i18nHelper";

const { userRoleList } = config;
const { GET_DATA } = ACTION_TYPES;
const storePath = "stats/roles";
const Store = namespace(storePath);

@Component
export default class StatUsersString extends Vue {
  @Store.State((state: StateStatRoles) => state.info)
  public readonly stat!: Dictionary<number>;

  @Store.Action(GET_DATA)
  public GET_DATA!: () => Promise<void>;

  public storePath = storePath;

  get allUsers(): number {
    let count = 0;
    Object.keys(this.stat).forEach(k => {
      count += this.stat[k];
    });
    return count;
  }

  get rolesStat(): Array<{ role: string; count: number }> {
    let result: Array<{ role: string; count: number }> = [];
    userRoleList.forEach(role => {
      let count = this.stat[role] || 0;
      if (role && count !== undefined) {
        result.push({ role, count });
      }
    });
    return result;
  }

  get roleString(): string {
    return this.rolesStat.reduce((out, item) => {
      out += `${out !== "" ? ", " : ""}${this.$tc($t(item.role), item.count)}`;
      return out;
    }, "");
  }

  private created() {
    this.GET_DATA();
  }
}
